import { AUTHORIZATION_ACTIONS, LOGIN_ERRORS } from 'constants/login-constant';
import { FETCH_CITY } from '../actions/endpoint-constants';
import { isEmpty } from '../common/utils/data-utils';
import {
  LOGIN,
  LOGOUT,
  RESET_EXCEED_LOGIN_TIMES,
  GET_USER_AUTHORIZATION,
  GET_COMPANY_PERMISSIONS,
  RETRIEVE_LKPP_TOKEN,
  LINK_COMPANY,
  PAX_GET_USER_AUTHORIZATION,
} from '../actions/login-actions';

export const isAdminUser = (gfbActions = []) =>
  [
    AUTHORIZATION_ACTIONS.MANAGE_COMPANY,
    AUTHORIZATION_ACTIONS.MANAGE_EMMPLOYEES,
  ].every(opt => gfbActions.indexOf(opt) !== -1);

export const isViewWebBooking = (gfbActions = []) =>
  [AUTHORIZATION_ACTIONS.VIEW_WEB_BOOKING].every(
    opt => gfbActions.indexOf(opt) !== -1,
  );

const initialState = {
  isExceedLoginAttempt: false,
  loginError: {},
  userInfo: {},
  sessionTimeout: false,
  isAdmin: false,
  verifyingTokenErrors: '',
  isFailedToVerifyPrecondition: false,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case LOGIN.START:
    case LOGIN.SUCCESS: {
      return { ...state, isExceedLoginTimes: false, loginError: {} };
    }

    case LOGIN.ERROR: {
      if (typeof action.data === 'object') {
        return {
          ...state,
          loginError: action.data,
        };
      }
      return { ...state, isExceedLoginTimes: true };
    }

    case LOGOUT.SUCCESS:
      return { ...initialState };

    case RESET_EXCEED_LOGIN_TIMES:
      return { ...state, isExceedLoginTimes: false };

    case GET_COMPANY_PERMISSIONS.SUCCESS: {
      const { data: { permissions = [] } } = action;
      return {
        ...state,
        isAdmin: isAdminUser(permissions),
        isViewWebBooking: isViewWebBooking(permissions),
      };
    }

    // TODO: deprecate after rollout. will be replaced by GET_COMPANY_PERMISSIONS.SUCCESS
    case GET_USER_AUTHORIZATION.SUCCESS: {
      const { data: { actions = [] } } = action;
      return {
        ...state,
        isAdmin: isAdminUser(actions),
        isViewWebBooking: isViewWebBooking(actions),
      };
    }

    // For pax user, all auth default to be true
    case PAX_GET_USER_AUTHORIZATION.SUCCESS: {
      return {
        ...state,
        isAdmin: false,
        isViewWebBooking: true,
      };
    }

    case RETRIEVE_LKPP_TOKEN.ERROR: {
      const { data } = action;
      return {
        ...state,
        verifyingTokenErrors: data.error,
      };
    }

    case FETCH_CITY.ERROR:
    case LINK_COMPANY.ERROR: {
      if (!isEmpty(action.data.reason)) {
        const { reason } = action.data;
        if (reason === LOGIN_ERRORS['preConditionFailed']) {
          return {
            ...state,
            isFailedToVerifyPrecondition: true,
          };
        }
      }
      return {
        ...state,
      };
    }

    default:
      return state;
  }
};
